import { useLocalStorageState } from "ahooks";
import useSWR from "swr";

import { useEffect, useRef } from "react";

import { AIRPORT_LIST, SUB_AIRPORTS } from "@/constants/airport";
import { ROUTES_PAGE_CHANGE_CONDITION } from "@/constants/eventName";
import useEvent from "@/hooks/useEvent";
import { dispatchEvent } from "@/hooks/useEventEmitter";

import { LocationEnum, LocationOption } from "./useLocationFilter";

export interface ConditionType {
  fromLocation: LocationOption[];
  toLocation: LocationOption[];
}

const getAirportCodes = (data: LocationOption[]) => {
  const country = data
    .filter((item) => item.type === LocationEnum.COUNTRY)
    .map((item) => item.code);

  const list1 = AIRPORT_LIST.filter((item) => country.includes(item.country)).map(
    (item) => item.iata
  );

  const list2 = data.filter((item) => item.type === LocationEnum.AIRPORT).map((item) => item.code);

  let region = data.filter((item) => item.type === LocationEnum.REGION).map((item) => item.code);

  if (list1.length === 0 && region.length === 0) {
    region = data.filter((item) => item.type === LocationEnum.COUNTRY).map((item) => item.code);
  }

  const list3 = Array.from(
    new Set(
      Object.keys(SUB_AIRPORTS)
        .filter((v) => region.includes(v))
        .map((key) => SUB_AIRPORTS[key])
        .flat()
    )
  );

  return [...list1, ...list2, ...list3];
};

const useCondition = () => {
  const initDataRef = useRef({
    fromLocation: [],
    toLocation: [],
  });

  const [localCondition, setLocalCondition] = useLocalStorageState<ConditionType>(
    "all-routes-store",
    {
      defaultValue: initDataRef.current,
    }
  );

  const { data: condition = localCondition, mutate } = useSWR<ConditionType>("all-routes-store");

  const setCondition = (data: ConditionType) => {
    setLocalCondition(data);
    mutate(data);
  };

  const onLocationSwapChange = useEvent(() => {
    if (condition) {
      setCondition({
        fromLocation: condition.toLocation,
        toLocation: condition.fromLocation,
      });
    }
  });

  useEffect(() => {
    if (condition) {
      setTimeout(() => {
        dispatchEvent(ROUTES_PAGE_CHANGE_CONDITION, {
          departure: getAirportCodes(condition.fromLocation),
          arrival: getAirportCodes(condition.toLocation),
        });
      }, 200);
    }
  }, [condition]);

  return {
    condition,
    setCondition,
    onLocationSwapChange,
  };
};

export default useCondition;
